import  { useState, useCallback, useEffect, useRef, useContext } from 'react';
// import Webcam from 'react-webcam';
import { useLocation } from 'react-router-dom';
import {
  Box,
  Flex,
  Image as ChakraImage,  // Rename the Chakra UI Image import
  Spacer,
  VStack,
  Text,
  Container,
  useDisclosure,
  // useBreakpointValue,
  Input,
} from "@chakra-ui/react";

import confetti from 'canvas-confetti';

import { GlobalWorkerOptions } from 'pdfjs-dist/build/pdf';
import * as pdfjsLib from 'pdfjs-dist';

import PropTypes from 'prop-types';

// uuid
import { v4 as uuid } from 'uuid';

// react-hook-form
import { useForm } from 'react-hook-form';

// form components
import { TextInput } from '../Form/Input/TextInput.jsx';
import { FormSelectSimple } from '../Form/Select/FormSelectSimple.jsx';
import { TextareaInput } from '../Form/Input/TextareaInput.jsx';
import { FormSelectMulti } from '../Form/Select/FormSelectMulti.jsx';
import { stateOptions } from '../Form/Select/stateOptions.jsx';
// import { ButtonQuaternaryWithIcon } from '../Form/Button/ButtonQuaternaryWithIcon.jsx';

// form buttons
import { ButtonPrimaryPlain } from '../Form/Button/ButtonPrimaryPlain.jsx';
import { ButtonSeptenaryWithIconOnly } from '../Form/Button/ButtonSeptenaryWithIconOnly.jsx';
import { ButtonNonaryWithIconOnly } from '../Form/Button/ButtonNonaryWithIconOnly.jsx';
import { ButtonDuodenaryPlain } from '../Form/Button/ButtonDuodenaryPlain.jsx';
import { ButtonQuaternaryPlain } from '../Form/Button/ButtonQuaternaryPlain.jsx';
import { ResponsiveCancelCloseButton } from '../Form/Button/ResponsiveCancelCloseButton.jsx';

// graphql and external components
// import { uploadFileToS3 } from '../AWS/S3/uploadFileToS3.jsx';
import { uploadStatementToS3 } from '../AWS/S3/uploadStatementToS3.jsx';
import { fetchDivisionOptions } from '../graphqlCompnents/Statement/fetchDivisionOptions.jsx';
import { fetchContactCompaniesByDivision } from '../graphqlCompnents/DJT/fetchContactCompaniesByDivision.jsx';
import { fetchAllUnits } from '../graphqlCompnents/Unit/fetchAllUnits.jsx';
import { fetchQuickBooksExpenseCategories } from '../graphqlCompnents/Statement/fetchQuickBooksExpenseCategories.jsx';
import { addIFTAFuelTracking } from '../graphqlCompnents/Statement/addIFTAFuelTracking.jsx';
import { fetchQuickTransaction } from '../graphqlCompnents/Statement/fetchQuickTransaction.jsx';
import { fetchManualTransaction } from '../graphqlCompnents/Statement/fetchManualTransaction.jsx';
import { fetchAccountsByTeamMember } from '../graphqlCompnents/Statement/fetchAccountsByTeamMember.jsx';
import { createCapitalOneReceipt } from '../graphqlCompnents/Statement/createCapitalOneReceipt.jsx';
// import { updateCapitalOneReceipt } from '../graphqlCompnents/Statement/updateCapitalOneReceipt.jsx';
import { updateCreditCardTransactionReceipt } from '../graphqlCompnents/Statement/updateCreditCardTransactionReceipt.jsx';
import { addStatementDocumentUnit } from '../graphqlCompnents/Statement/addStatementDocumentUnit.jsx';
import { fetchCapitalOneReceiptByInstantNotificationId } from '../graphqlCompnents/Statement/fetchCapitalOneReceiptByInstantNotificationId.jsx';
import { updateInstantNotification } from '../graphqlCompnents/Statement/updateInstantNotification.jsx';
import { addStatementDocumentLink } from '../graphqlCompnents/Statement/addStatementDocumentLink.jsx';
import { updateTransaction } from '../graphqlCompnents/Statement/updateTransaction.jsx';
import { updateIFTAActiveStatus } from '../graphqlCompnents/Statement/updateIFTAActiveStatus.jsx';
import { fetchInstantNotificationById } from '../graphqlCompnents/Statement/fetchInstantNotificationById.jsx';
import { logUploadEvent } from '../functions/logUploadEvent.jsx';

// generic funcitons
import { stripToNumbersAndDecimal } from '../functions/number.jsx';

// globals
import { AppContext } from '../AppContext.jsx';

// modal
import { CenteredSingleButtonConfirmationModal } from '../Modal/CenteredSingleButtonConfirmationModal.jsx';
import { delay } from '../functions/generic.jsx';

// Helper function for delay
// const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
import { spellOutDate } from '../functions/dateTime.jsx';
import { TransactionManager, DatabaseOperation, withRetry } from '../functions/transactionManager.jsx';

import { CenteredSubmitWithProgressScrollModal } from '../Modal/CenteredSubmitWithProgressScrollModal.jsx';

// parse query for possible id
function useQueryParams() {
  return new URLSearchParams(useLocation().search);
}

const STATEMENT_TYPE_OPTIONS = [
  { value: '', label: '-- Select Statement Type --' },
  { value: 'receipt', label: 'Receipt' },
  { value: 'credit', label: 'Vendor Credit Note' },
  { value: 'refund', label: 'Credit Card Refund' },
  { value: 'invoice', label: 'Invoice' },
];

export const QuickCameraUploadStatement = (props) => {

  const {
    id,
    showCancel = false,
    selectedActionType='upload',
    attachReceiptParams,
    targetTeamMemberId = null,
    forceFileMode = false,
    onClose
  } = props;

  // grab global context values
  const { store } = useContext(AppContext);

  const cardHolderName = store?.userData?.name||'';

  const isMobile = store?.userIsMobile;
  // console.info('isMobile: ', isMobile)

  // get the current environment sandbox || production
  const qbEnv = store?.qbEnvironment || 'sandbox'

  // set the current users team member id
  const currentTeamMemberId = store?.userData?.id

  // current users default division
  const usersDivisionId = store?.userData?.divisionId

  const uploadSessionId = useRef(uuid());

  // current user groups
  // const userGroups = store?.userData?.groups

  // const isSupervisor = userGroups?.includes('supervisor')

  const { isOpen: isSubmitModalOpen , onOpen: onSubmitModalOpen, onClose: onSubmitModalClose } = useDisclosure()
  
  const [confirmationModalIcon, setConfirmationModalIcon] = useState('outlinecheckcircle');
  const [confirmationModalIconColor, setConfirmationModalIconColor] = useState('var(--success-green)');

  const [ submitModalContent, setSubmitModalContent ] = useState(null)
  const [ submitModalCloseDisabled, setSubmitModalCloseDisabled ] = useState(true)
  const [ submissionProgress, setSubmissionProgress ] = useState(0)
  
  async function handleSubmitModalClosed() {
    onSubmitModalClose()
    await delay(500)
    if (externallyOpened && !targetTeamMemberId) {
      handleRedirect();
    } else {
      onClose()
    }
  }

  // https://brain-dev.spikeenterprise.io/receipt-upload?id=c91bf7da-3b27-4444-aca3-ef4b0e49e745
  // https://brain-dev.spikeenterprise.io/receipt-upload?id=dd4b33c9-4458-42dd-9871-5972937c5b01
  const query = useQueryParams();

  let hasInstantNotification = attachReceiptParams?.hasInstantNotification||false;
  let externallyOpened = false;
  let transactionId = id||null;

  // console.warn('TRANSACTION ID: ', transactionId)
  
  if (!transactionId) {
    // console.warn('GETTING TRANSACTION ID FROM QUERY')
    transactionId = query.get('id')||null
    externallyOpened = true;
    hasInstantNotification = true;
  }

  // console.log('transactionId: ', transactionId)

  let instantNotificationId = hasInstantNotification ? attachReceiptParams?.id||transactionId : null;
  
  const logStep = useCallback((step, extra = {}) => {
    logUploadEvent(step, {
      sessionId:              uploadSessionId.current,
      teamMemberId:           currentTeamMemberId,
      instantNotificationId:  instantNotificationId,
      transactionId:          transactionId,
      hasInstantNotification: hasInstantNotification,
      externallyOpened:       externallyOpened,
      env:                    qbEnv,
      ...extra,
    });
  }, [currentTeamMemberId, instantNotificationId, transactionId,
      hasInstantNotification, externallyOpened, qbEnv]);

  // console.warn('instantNotificationId: ', instantNotificationId)

  // console.info('SETTING TRANSACTION ID: ', transactionId)

  // const hasInstantNotification = attachReceiptParams?.hasInstantNotification||false;
  // const instantNotificationId = hasInstantNotification ? attachReceiptParams?.id : null;
  const creditCardTransactionId = hasInstantNotification ? null : attachReceiptParams?.id||props.id;
  // console.warn('creditCardTransactionId: ', creditCardTransactionId)
  // console.info('hasInstantNotification: ', hasInstantNotification)
  // console.info('instantNotificationId: ', instantNotificationId)
  // console.info('creditCardTransactionId: ', creditCardTransactionId)
  // console.info('attachReceiptParams: ', attachReceiptParams)
  const plaidCreditCardTransactionId = attachReceiptParams?.id||null;

  // modal
  const { isOpen: isConfirmModalOpen , onOpen: onConfirmModalOpen, onClose: onConfirmModalClose } = useDisclosure()

  const [ receiptHasIssue, setReceiptHasIssue ] = useState(false);
  const [ showRetakePhotoWithIssue, setShowRetakePhotoWithIssue ] = useState(false);
  // const [ receiptIssue, setReceiptIssue ] = useState('');
  // const [ showReceiptUploadOptions, setShowReceiptUploadOptions ] = useState(true);
  // const [ editModeIsLocked, setEditModeIsLocked ] = useState(false);
  const [ isNotificationExpired, setIsNotificationExpired ] = useState(false);
  const [ isReceiptUploaded, setIsReceiptUploaded ] = useState(false);
  const [ effectiveActionType, setEffectiveActionType ] = useState(selectedActionType);
  const [ receiptCheckComplete, setReceiptCheckComplete ] = useState(false);
  const [ confirmationModalContent, setConfirmationModalContent ] = useState(null);
  const [ confirmationModalHeaderText, setConfirmationModalHeaderText ] = useState(null);
  const [ showConfirmationModal, setShowConfirmationModal ] = useState(false);
  const [ isAlreadyUploaded, setIsAlreadyUploaded ] = useState(null);
  // const [ instantNotificationData, setInstantNotificationData ] = useState(null);
  const [ priorAttemptFailed, setPriorAttemptFailed ] = useState(false);
  const [ isEditMode, setIsEditMode ] = useState(false);
  const [ uploadingNewReceipt, setUploadingNewReceipt ] = useState(false);
  const [selectedClient, setSelectedClient] = useState('');
  const [clients, setClients] = useState([])
  const [combinedImageFile, setCombinedImageFile] = useState(null);
  // const [ file, setFile ] = useState(null)
  const [ images, setImages ] = useState([]);
  const [ streaming, setStreaming ] = useState(false);
  const [ previewMode, setPreviewMode] = useState(false);
  // const [ mode, setMode] = useState('Single');  // Track user selection of Single or Combine and now File
  const [ mode, setMode] = useState(forceFileMode ? 'File' : 'Single');
  const [ showUploadForm, setShowUploadForm] = useState(false);
  const [ showUploadFormRest, setShowUploadFormRest ] = useState(false);
  // const [ isVideoLoaded, setIsVideoLoaded] = useState(false);
  const [ selectedUnits, setSelectedUnits] = useState([]);
  const [ unitOptions, setUnitOptions] = useState([])
  const [ iftaUnitOptions, setIFTAUnitOptions ] = useState([])
  const [ selectedIFTAUnitOption, setSelectedIFTAUnitOption ] = useState([])
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const [initializationAttempts, setInitializationAttempts] = useState(0);

  const MAX_RETRY_ATTEMPTS = 3;
  const RETRY_DELAY = 500; // 500ms between retries
  const S3_UPLOAD_TIMEOUT_MS = 60000; // 60 seconds — covers poor mobile connections

  // Helper function for delay
  const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  const uploadWithTimeout = (uploadFn) => Promise.race([
    uploadFn(),
    new Promise((_, reject) =>
      setTimeout(
        () => reject(new Error('Upload timed out — please check your connection and try again.')),
        S3_UPLOAD_TIMEOUT_MS
      )
    )
  ]);

  useEffect(() => {

    const checkTransactions = async () => {
      if (!transactionId) {
        setIsAlreadyUploaded(false);
        setReceiptCheckComplete(true);
        return;
      }

      try {
        // For externally-opened instant notification flows, use the notification's
        // own status fields as the source of truth rather than querying the receipt
        // table. This allows us to distinguish "never tried", "tried but stalled",
        // and "fully completed".
        if (externallyOpened && hasInstantNotification) {
          const notification = await fetchInstantNotificationById(transactionId);

          if (!notification) {
            // Could not fetch the notification — let them proceed and the
            // formSubmit final check will catch any real duplicates.
            // console.warn('Could not fetch notification record, proceeding cautiously');
            setIsAlreadyUploaded(false);

            logStep('DUPLICATE_CHECK_DONE', {
              isAlreadyUploaded: isFullyCompleted ? true : false,
              priorAttemptFailed: wasPreviouslyAttempted ? true : false,
            });
            setReceiptCheckComplete(true);
            return;
          }

          // setInstantNotificationData(notification);

          const isFullyCompleted = notification.isSubmitted === true && notification.status === 'has-receipt';
          const wasPreviouslyAttempted = notification.isSubmitted === false && notification.status === 'pending';
          
          logStep('FORM_OPENED', {
            notificationStatus:     notification?.status,
            isFullyCompleted,
            wasPreviouslyAttempted,
          });

          if (isFullyCompleted) {
            // Receipt was fully uploaded — block and confirm
            // console.warn('Notification already submitted and complete');
            setIsAlreadyUploaded(true);
            setConfirmationModalHeaderText('Receipt Already Uploaded');
            setConfirmationModalContent('This receipt has already been uploaded. You\'re all set!');
            setShowConfirmationModal(true);
            onConfirmModalOpen();

          } else if (wasPreviouslyAttempted) {
            // Upload was started before but the outcome is unknown (stalled,
            // network failure, browser closed). Allow retry with a warning.
            // console.warn('Notification was previously attempted but not confirmed complete — allowing retry');
            setPriorAttemptFailed(true);
            setIsAlreadyUploaded(false);
            setIsEditMode(false);

          } else {
            // Clean slate — needs-receipt or any other status
            // console.warn('Notification is available for upload');
            setIsAlreadyUploaded(false);
            setIsEditMode(false);
          }

          setReceiptCheckComplete(true);
          return;
        }

        // Non-instant-notification path: fall back to receipt table lookup
        // (preemptive uploads, manual uploads, etc.)
        const transactions = await fetchCapitalOneReceiptByInstantNotificationId(transactionId);
        const transactionsCount = transactions.length;
        // console.warn('transactionsCount: ', transactionsCount);

        if (transactionsCount > 0) {
          setIsAlreadyUploaded(true);
          let transaction = transactions[0];
          if (transaction?.hasIssue === true) {
            // (existing commented-out issue handling preserved here)
          } else {
            setConfirmationModalHeaderText('Receipt Already Uploaded');
            setConfirmationModalContent('This receipt has already been uploaded.');
            setShowConfirmationModal(true);
            onConfirmModalOpen();
          }
        } else {
          setIsAlreadyUploaded(false);
          setIsEditMode(false);
        }
        setReceiptCheckComplete(true);

      } catch (error) {
        console.error('Error in checkTransactions:', error);
        setReceiptCheckComplete(true);
      }
    };

    if (selectedActionType !== 'upload-with-transaction' && selectedActionType !== 'edit') {
      checkTransactions();
    } else {
      if (selectedActionType === 'edit') {
        // console.info('EDITING RECEIPT: ', attachReceiptParams)
        setShowUploadForm(true);
        setIsAlreadyUploaded(true);
        setIsEditMode(true);
        setValue('addedNotes', attachReceiptParams?.addedNotes||'');
        setValue('odometer', attachReceiptParams?.odometer||'');
        setValue('gallons', attachReceiptParams?.gallons||'');
        (attachReceiptParams?.iftaFuelTaxTrackId ) && updateSelectedState({ value: attachReceiptParams?.stateTwoChar });
        (attachReceiptParams?.clientId) && updateSelectedClient({ value: attachReceiptParams?.clientId });
        (attachReceiptParams?.iftaFuelTaxTrackId ) && handleIFTAUnitChange({ value: attachReceiptParams?.unitId });
        // setValue('selectClient', attachReceiptParams?.clientId||'');
        // setValue('selectClient', attachReceiptParams?.clientId||'');

        // setShowReceiptUploadOptions(false);
      } else {
        setIsAlreadyUploaded(false);
        setIsEditMode(false);
        setReceiptCheckComplete(true);
      }
      
    }
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[transactionId, selectedActionType])

  useEffect(() => {
    if (attachReceiptParams?.hasIssue && clients?.length>0 && iftaUnitOptions?.length>0) {
      // console.warn('SHOULD SEE FIX ISSUE')
      setShowUploadFormRest(true)
      setIsAlreadyUploaded(true);
      setReceiptHasIssue(true);
      // setReceiptIssue(attachReceiptParams?.issue||'');
      setIsEditMode(true);
      setValue('addedNotes', attachReceiptParams?.addedNotes||'');
      setValue('odometer', attachReceiptParams?.odometer||'');
      setValue('gallons', attachReceiptParams?.gallons||'');
      (attachReceiptParams?.iftaFuelTaxTrackId ) && updateSelectedState({ value: attachReceiptParams?.stateTwoChar });
      (attachReceiptParams?.clientId) && updateSelectedClient({ value: attachReceiptParams?.clientId });
      (attachReceiptParams?.iftaFuelTaxTrackId ) && handleIFTAUnitChange({ value: attachReceiptParams?.unitId });
      // setValue('selectClient', attachReceiptParams?.clientId||'');
      // setValue('selectClient', attachReceiptParams?.clientId||'');

      // setShowReceiptUploadOptions(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attachReceiptParams, clients, iftaUnitOptions])

  const [ receiptIssueLog, setReceiptIssueLog ] = useState(attachReceiptParams?.issue||'');
  
  const handleUpdateReceiptIssue = (issue) => {
    // add admin name to the issue test with a colon and a hard return
    const issues = receiptIssueLog + cardHolderName + ': ' + issue + '::cr::';
    // setReceiptIssue(issues);
    setValue('updateReceiptIssue', issues);
  }

  async function handleConfirmModalClosed() {
    // either redirect to user receipts or close the modal
    if (isNotificationExpired) {
      if (isReceiptUploaded) {
        onConfirmModalClose()
        await delay(500)
        if (externallyOpened && !targetTeamMemberId) {
          handleRedirect();
        } else {
          handleClose();
        }
      } else {
        onConfirmModalClose()
      }

    } else {
      onConfirmModalClose()
      await delay(500)
      if (externallyOpened && !targetTeamMemberId) {
        handleRedirect();
      } else {
        handleClose();
      }
    }
  }

  const canvasRef = useRef(null);
  const videoRef = useRef(null);
  const myConfetti = useRef(null); // Store confetti instance in a ref

  const defaults = {
    spread: 360,
    ticks: 50,
    gravity: 0,
    decay: 0.94,
    startVelocity: 30,
    colors: ['#FFE400', '#FFBD00', '#E89400', '#FFCA6C', '#FDFFB8']
  };

  useEffect(() => {
    if (canvasRef.current && !myConfetti.current) {
      myConfetti.current = confetti.create(canvasRef.current, {
        resize: true,
        useWorker: true
      });
    }
  }, []);

  // Warn the cardholder if they try to close/navigate away while an upload is in progress
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isSubmitModalOpen && submitModalCloseDisabled) {
        e.preventDefault();
        // Modern browsers show their own generic message; this text is a fallback
        e.returnValue = 'Your receipt upload is still in progress. If you close this page, you may need to try again.';
        return e.returnValue;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isSubmitModalOpen, submitModalCloseDisabled]);

  const shoot = () => {
    if (myConfetti.current) {
      // Star confetti
      myConfetti.current({
        ...defaults,
        particleCount: 40,
        scalar: 1.2,
        shapes: ['star']
      });

      // Small circle confetti for contrast
      myConfetti.current({
        ...defaults,
        particleCount: 10,
        scalar: 0.75,
        shapes: ['circle']
      });
    }
  };

  const triggerConfetti = () => {
    shoot(); // First shot
    setTimeout(shoot, 100); // Second shot
    setTimeout(shoot, 200); // Third shot
  };

  useEffect(() => {
    // Set the workerSrc to the file in the public folder
    GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';
  }, []);

  // const handleShowReplaceReceipt = (show) => () => {
  //   // setShowReceiptUploadOptions(show);
  //   // setEditModeIsLocked(true);
  //   if (show===true) {
  //     console.log('showing the replace receipt options')
  //   } else {
  //     console.log('hiding the replace receipt options and setting showUploadForm to true')
  //     setShowUploadForm(true);
  //     setShowUploadFormRest(true);
  //   }
  // }

  useEffect(() => {
    if (showConfirmationModal && confirmationModalContent && confirmationModalHeaderText) {
      // if (isNotificationExpired && !isReceiptUploaded) {
      if (!isReceiptUploaded) {
          onConfirmModalOpen();
      } else {
        triggerConfetti();
        // onConfirmModalOpen();
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[showConfirmationModal, confirmationModalContent, confirmationModalHeaderText])

  const [ transactionData, setTransactionData ] = useState([]);
  useEffect(() => {
    console.log('receiptCheckComplete: ', receiptCheckComplete)
    console.log('isAlreadyUploaded: ', isAlreadyUploaded)
    // if (!receiptCheckComplete || isAlreadyUploaded) {
    //   return;
    // }
    if (!receiptCheckComplete) return;
    
    const getTeamMemberAccounts = async (tmId, env) => {
      if (!tmId) {
        console.error('No team member id provided.');
        return;
      }
      try {
        const accounts = await fetchAccountsByTeamMember(env, tmId);
        console.log('accounts: ', accounts)

        // Extract cardLastFour values
        const cards = accounts.map(account => account.cardLastFour);
        console.log('cards: ', cards)

        // setTeamMemberCards(cards)
        return cards;
      } catch (error) {
        console.error('Failed to fetch team member accounts:', error);
      }
    }

    const fetchTransaction = async (id) => {
      if (!id) {
        console.error('No transaction id provided.');
        return;
      }
      try {
        console.warn('effectiveActionType: ', effectiveActionType)
        console.warn('hasInstantNotification: ', hasInstantNotification)
        let transaction = {};
        if (effectiveActionType === 'upload-with-transaction') {
          console.log('with transaction');
          transaction = attachReceiptParams;
        } else if (effectiveActionType === 'upload' && hasInstantNotification) {
          console.warn('fetching transaction for instant notification id: ', id);
          transaction = await fetchQuickTransaction(id);
        } else if (effectiveActionType === 'fix-issue') {
          console.warn('loading fix-issue with params: ', attachReceiptParams);
          transaction = attachReceiptParams;
        } else {
          console.warn('fetching transaction for manual transaction id: ', id);
          transaction = await fetchManualTransaction(id);
    
          if (!transaction || Object.keys(transaction).length === 0) {
            console.warn('No transaction found, generating a new ID.');
            transaction = { id: uuid() };
          }
        }
        console.info('new transaction data: ', transaction);
        setTransactionData(transaction);
        return transaction;
      } catch (error) {
        console.error('Failed to fetch transaction:', error);
        if (!isNotificationExpired) {
          // alert('Failed to fetch transaction.');
          handleRedirect();
        }
      }
    };

    const verifyCardHolder = async (id, env) => {
      try {
        console.log('id: ', id);
        const transaction = await fetchTransaction(id);
        console.info('transaction: ', transaction)
        const usersCards = await getTeamMemberAccounts(currentTeamMemberId, env);
        console.info('usersCards: ', usersCards)
        const cardMatch = usersCards.includes(transaction?.accountNumber);
        console.info('transaction.accountNumber: ', transaction?.accountNumber);
        console.info('cardMatch: ', cardMatch);
        // setIsUserCardVerified(cardMatch);
      } catch (error) {
        // alert('Failed to verify card holder.');
        console.error('Failed to verify card holder:', error);
        handleRedirect();
      }

    }

    if (targetTeamMemberId) {
      // Admin flow — no card verification needed, admin is acting on behalf of cardholder
      return;
    }

    if (transactionId && currentTeamMemberId && selectedActionType) {
      console.info('verifying card holder: ', transactionId)
      verifyCardHolder(transactionId, qbEnv)
    } else {
      console.error('Missing required data to verify card holder.');
    }
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[
    receiptCheckComplete, 
    isAlreadyUploaded, 
    transactionId, 
    currentTeamMemberId, 
    qbEnv, 
    effectiveActionType, 
    hasInstantNotification,
    isNotificationExpired,
    selectedActionType,
    attachReceiptParams
  ])

  const fileInputRef = useRef(null);
  const containerRef = useRef(null);

  // --- REACT-HOOK-FORM ---
  const { 
    setError, 
    control, 
    register, 
    handleSubmit, 
    clearErrors,
    setValue, 
    reset, 
    formState: { 
      isSubmitting,
      errors
    }} = useForm({
      mode: 'onSubmit',
      // reValidateMode: 'onChange',
      reValidateMode: 'onBlur',
      defaultValues: {
        odometer: '',
        gallons: '',
        addedNotes: '',
        selectDivision: '',
        selectClient: '',
        selectExpenseCategory: '',
        selectState: '',
        selectOTRUnit: '',
        units: [],
      }
  });

  const onError = (errors, e) => console.log(errors, e);

  useEffect(() => {
    const fetchAndSetUnits = async () => {
      try {
        const units = await fetchAllUnits();
        // console.log('units: ', units)
        units.sort((a, b) => a.codeSortable.localeCompare(b.codeSortable));

        // create IFTA unit options
        const iftaUnits = units.filter(unit => unit.irpiftaRegistered === true && unit.isActive === true);
        
        const iftaUnitOptions = iftaUnits.map(unit => ({
          value: unit.id,
          // label: `${unit.code} - ${unit.type.name} / ${unit.subType.name}`
          label: `Unit ${unit.code} - ${unit.subType.name}`
        }));

        setIFTAUnitOptions(iftaUnitOptions)

        // reduce down to active units - updating 2025-02-14 to show all units
        // const activeUnits = units.filter(unit => unit.isActive === true);

        // Create unitOptions - updating 2025-02-14 to show all units
        // const options = activeUnits.map(unit => ({
        const options = units.map(unit => ({
            value: unit.id,
            // label: `${unit.code} - ${unit.type.name} / ${unit.subType.name}`
            label: `Unit ${unit.code} - ${unit.subType.name}`
          }));
        
        // console.log('units: ', units)
        setUnitOptions(options)

      } catch (error) {
        console.error('Failed to fetch units:', error);
      }
    };

    fetchAndSetUnits();

  }, []); 

  const [ selectedDivision, setSelectedDivision ] = useState('');
  const [ divisionOptions, setDivisionOptions ] = useState([])
  
  useEffect(() => {
    const fetchDivisions = async () => {
      try {
        // Fetch divisions for 'all'
        const responseAll = await fetchDivisionOptions('all');
        const optionsAll = responseAll.map(division => ({
          value: division.id,
          label: division.prettyname,
        }));

        // Fetch divisions for 'special'
        const responseSpecial = await fetchDivisionOptions('special');
        const optionsSpecial = responseSpecial.map(division => ({
          value: division.id,
          label: division.prettyname,
        }));

        // Combine and sort options
        const combinedOptions = [...optionsAll, ...optionsSpecial].sort((a, b) => 
          a.label.localeCompare(b.label)
        );
        setDivisionOptions(combinedOptions);

        let divisionIdToMatch = null;

        // If attachReceiptParams has a divisionId, use it
        if (attachReceiptParams?.hasIssue===true && attachReceiptParams?.divisionId) {
          divisionIdToMatch = attachReceiptParams?.divisionId;
        } else {
          // Find the division that matches usersDivisionId
          divisionIdToMatch = usersDivisionId;
        }

        const matchingDivision = combinedOptions.find(option => option.value === divisionIdToMatch);

        // Set selectedDivision if a match is found
        if (matchingDivision) {
          setSelectedDivision(matchingDivision);
          // setValue('selectDivision', matchingDivision.value);
          setValue('selectDivision', matchingDivision);
        }

      } catch (error) {
        console.error('Failed to fetch divisions:', error);
      }
    };

    if (usersDivisionId) {
      fetchDivisions();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usersDivisionId, attachReceiptParams]); // Add usersDivisionId to the dependency array to rerun if it changes


  useEffect(() => {
    const fetchClients = async (divisionId) => {
      if (!divisionId) return;

      try {
        const response = await fetchContactCompaniesByDivision(divisionId);
        console.info('fetchContactCompaniesByDivision response: ', response)
        const clientOptions = response.map(client => ({
          value: client.value,
          label: client.label,
        }));

        // Create a new array instead of mutating
        const updatedClients = [
          // { value: '', label: 'Select a Client or None', disabled: true }, // Add to start
          ...clientOptions,
          { value: 'none', label: '- None -' } // Add to end
        ];

        setClients(updatedClients);

        if (updatedClients.length === 1) {
          setSelectedClient(updatedClients[0]);
          setValue('selectClient', updatedClients[0]); // Assuming you're using React Hook Form
        }

        // Ensure there is at least one option before setting state
        // if (updatedClients.length > 0) {
        //   setSelectedClient(updatedClients[0]);
        //   setValue('selectClient', updatedClients[0]); // Assuming you're using React Hook Form
        // }
      } catch (error) {
        console.error('Failed to fetch clients:', error);
      }
    };

    if (selectedDivision?.value) {
      fetchClients(selectedDivision.value);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDivision]);

  useEffect(() => {
    const getClient = (id) => {
      const client = clients.find((client) => client.value === id);

      // If no client is found, return null or a default value
      if (!client) return '';

      // Return the formatted object based on the found client
      const clientOption = {
        value: client.value,
        label: client.label,
      };
      setSelectedClient(clientOption);
    };

    (transactionData?.capitalOneCreditCardTransactionReceipt?.clientId && clients.length) && getClient(transactionData?.capitalOneCreditCardTransactionReceipt?.clientId);
  },[clients, transactionData])

  //fetchQuickBooksExpenseCategories
  const [ expenseCategories, setExpenseCategories ] = useState([])
  const [ selectedExpenseCategory, setSelectedExpenseCategory ] = useState('')
  const [ isIFTATracked, setIsIFTATracked ] = useState(false)
  const [ isUnitRequired, setIsUnitRequired ] = useState(false)
  // Read at validation time so the Units requirement always reflects the
  // currently selected category. Controller rules are merged into RHF's field
  // registry and a removed `required` key is never cleared, so the rule itself
  // must not change shape between categories.
  const isUnitRequiredRef = useRef(false)

  useEffect(() => {
    const fetchAllExpenseCategories = async () => {
      try {
        const response = await fetchQuickBooksExpenseCategories(qbEnv);
        console.warn('🐞 fetchQuickBooksExpenseCategories response: ', response)
        const categories = response.map(expense => ({
          value: expense.qbId,
          label: expense.appName,
          isIFTATracked: (expense?.isIFTATracked===true) ? true : false,
          isUnitRequired: (expense?.isUnitRequired===true) ? true : false,
        }));

        // Add the ' -- None --' option at the beginning
        // categories.unshift({ value: '', label: ' - None -' });

        console.log('🐞 categories: ', categories)

        setExpenseCategories(categories);
        // setSelectedExpenseCategory(categories[0])
        // setValue('selectExpenseCategory', categories[0])
      } catch (error) {
        console.error('Failed to fetch expense categories:', error);
      }
    };

    fetchAllExpenseCategories();
  }, [qbEnv]);

  const handleRedirect = () => {

    const baseUrl = `${window.location.origin}/user-receipts`;

        // Perform the redirect
    window.location.href = baseUrl;

    // window.location.href = 'https://brain.spikeenterprise.io';
    // let hostname = window.location.hostname;
    // window.location.href = hostname + '/user-receipts';
    // window.location.href = `https://${hostname}/user-receipts`;
  }

  const [ selectedStatementType, setSelectedStatementType ] = useState('');

  useEffect(() => {
    const statementType = STATEMENT_TYPE_OPTIONS.find(option => option.value === 'receipt');
    setSelectedStatementType(statementType);
    setValue('selectStatementType', statementType.value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateSelectedStatementType = (event) => {
    setSelectedStatementType(event);
    setValue('selectStatementType', event.value)
  };

  const updateSelectedExpenseCategory = (event) => {
    const unitRequired = event?.isUnitRequired === true;

    setIsIFTATracked(event?.isIFTATracked === true);
    setIsUnitRequired(unitRequired);
    isUnitRequiredRef.current = unitRequired;

    setSelectedExpenseCategory(event);
    setValue('selectExpenseCategory', event.value);
    clearErrors('selectExpenseCategory');

    // Requirement is enforced on submit by the Units validate rule.
    // Clear any error left over from a previously selected category.
    clearErrors('units');

    setShowUploadFormRest(true);
  }

  // if we are in edit mode we need to prepopulate the selected expense category
  useEffect(() => {
    const getExpenseCategory = (id) => {
      if (!id) return;
      console.info('expenseCategories: ', expenseCategories)
      const expenseObj = expenseCategories.find((category) => category.value === id);
      console.info('expenseObj: ', expenseObj);
      // If no expense is found, return null or a default value
      if (!expenseObj) return '';
  
      // Return the formatted object based on the found expense
      const expenseCategory = {
        value: expenseObj.value,
        label: expenseObj.label,
        isIFTATracked: expenseObj?.isIFTATracked === true ? true : false,
        isUnitRequired: expenseObj?.isUnitRequired === true ? true : false,
      };
      updateSelectedExpenseCategory(expenseCategory)
      console.log('expenseCategory: ', expenseCategory);
      // setSelectedExpenseCategory(expenseCategory);
    };

    if (expenseCategories?.length>0 && transactionData) {
      console.info('transactionData: ', transactionData)
      let expenseCategoryId = null;
      if (transactionData?.capitalOneCreditCardTransactionReceipt?.expenseCategoryId) {
        expenseCategoryId = transactionData.capitalOneCreditCardTransactionReceipt.expenseCategoryId;
      }
      if (transactionData?.expenseCategoryId) {
        expenseCategoryId = transactionData.expenseCategoryId;
      }
      console.info('expenseCategoryId: ', expenseCategoryId);
      getExpenseCategory(expenseCategoryId);
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[expenseCategories, transactionData])

  const updateSelectedDivision = (event) => {
    console.log('updateSelectedDivision event: ', event)
    setSelectedClient('');
    setValue('selectClient', '');
    setSelectedDivision(event);
    setValue('selectDivision', event);
  };

  const updateSelectedClient = (event) => {
    console.info('updateSelectedClient event: ', event)
    console.warn('clients: ', clients)
    if (!event.label) {
      const clientSelected = clients.find(client => client.value === event.value);
      event.label = clientSelected?.label;
    }
    if (event.value) {
      clearErrors('selectClient');
    }
    console.warn('SETTING CLIENT TO EVENT: ', event)
    setSelectedClient(event);
    setValue('selectClient', event.value)
    console.warn('Setting clientId to: ', event.value)
  };

  // we need to see if there are any selected units in the transaction data and prepopulate the selectedUnits based on those if they exist
  useEffect(() => {
    const getUnits = async (units) => {
      const selectedUnits = units?.map(unit => {
        // Find the matching unit option where the `value` matches the `unitId`
        const matchedOption = unitOptions.find(option => option.value === unit.unitId);
        
        // Return the matched option (or null if not found)
        return matchedOption || null;
      }).filter(option => option !== null);  // Filter out any nulls if no matches are found
      
      console.log('unit options: ', selectedUnits);
      setSelectedUnits(selectedUnits);
      setValue('units', selectedUnits.map(unit => unit.value));

    }
    
    if (unitOptions?.length>0) {
      if (transactionData?.units?.length>0 || transactionData?.capitalOneCreditCardTransactionReceipt?.units?.items?.length>0) {
        let unitsArray = transactionData?.units?.length>0 ? transactionData.units : transactionData?.capitalOneCreditCardTransactionReceipt?.units?.items;
        getUnits(unitsArray);
      }
    }

    // ((transactionData?.units?.length>0 || transactionData?.capitalOneCreditCardTransactionReceipt?.units?.items?.length>0) && unitOptions.length) && getUnits(transactionData?.capitalOneCreditCardTransactionReceipt?.units?.items);
  },[transactionData, unitOptions])

  // const handleUnitsChange = (event, action) => {
  //   if (action?.action === 'select-option') {
  //     clearErrors('units')
  //     const addedOption = { value: action?.option?.value, label: action?.option?.label, key: action?.option?.value };
  //     setSelectedUnits([...selectedUnits, addedOption]);
  //   }
  //   if (action?.action === 'remove-value') {
  //     const removedOption = { value: action?.removedValue?.value, label: action?.removedValue?.label, key: action?.removedValue?.value };
  //     const newUnits = selectedUnits.filter((unit) => unit.value !== removedOption.value);
  //     setSelectedUnits(newUnits);
  //   }
  // };

  const handleUnitsChange = (event, action) => {
    let updatedUnits = [];
  
    if (action?.action === "select-option") {
      updatedUnits = [...selectedUnits, { value: action.option.value, label: action.option.label }];
    }
    
    if (action?.action === "remove-value") {
      updatedUnits = selectedUnits.filter((unit) => unit.value !== action.removedValue.value);
    }
  
    setSelectedUnits(updatedUnits);
    
    // ✅ Store an array of unit IDs instead of objects in react-hook-form
    setValue("units", updatedUnits.map(unit => unit.value));
  
    // ✅ Clear errors when user selects something
    if (updatedUnits.length > 0) {
      clearErrors("units");
    }
  };

  const [ selectedState, setSelectedState ] = useState('')
  const updateSelectedState = (event) => {
    if (event.value==='') {
      setSelectedState(event)
      setValue('selectState', event)
      setError('selectState', {
        type: 'preemptive',
        message: 'State is required'
      })
    } else {
      if (!event.label) {
        const stateSelected = stateOptions.find(state => state.value === event.value);
        event.label = stateSelected.label;
      }
      setSelectedState(event)
      setValue('selectState', event)
      clearErrors('selectState')
    }
  }

  const handleIFTAUnitChange = (event) => {
    console.log(' 🐞  handleIFTAUnitChange event: ', event)
    if (!event.label) {
      const unitSelected = iftaUnitOptions.find(unit => unit.value === event.value);
      event.label = unitSelected.label;
    }
    setSelectedIFTAUnitOption(event);
    setValue('selectOTRUnit', event.value)
    clearErrors('selectOTRUnit')
  };

  const [ modeIsLocked, setModeIsLocked ] = useState(false);
  const [ showMultiPictureButtons, setShowMultiPictureButtons ] = useState(false);
  const webcamRef = useRef(null);

  const [deviceId, setDeviceId] = useState(null); // To handle camera switching
  const [devices, setDevices] = useState([]); // To store available cameras
  const [ refreshCamera, setRefreshCamera ] = useState(0);
  const handleRefreshCamera = () => {
    setRefreshCamera(prev => prev + 1); // Increment to trigger useEffect
  };

  const handleDevices = useCallback(
    (mediaDevices) =>
      setDevices(mediaDevices.filter(({ kind }) => kind === "videoinput")),
    []
  );

  useEffect(() => {
    if (forceFileMode) return; // Don't touch media devices if camera is disabled
    
    const updateDevices = () => {
      navigator.mediaDevices
        .enumerateDevices()
        .then(handleDevices)
        .catch((err) => console.error("Error accessing media devices:", err));
    };

    navigator.mediaDevices.addEventListener("devicechange", updateDevices);
    updateDevices();

    return () => {
      navigator.mediaDevices.removeEventListener("devicechange", updateDevices);
    };
  }, [handleDevices, forceFileMode]);

  useEffect(() => {
    const video = videoRef.current; // capture at effect time
    let mounted = true;
    let stream = null;
  
    const initializeCamera = async (retryCount = 0) => {
      if (!mounted) return;
  
      try {
        // Clean up any existing streams first
        if (videoRef.current?.srcObject) {
          const tracks = videoRef.current.srcObject.getTracks();
          tracks.forEach(track => track.stop());
          videoRef.current.srcObject = null;
        }
  
        if (!isDrawerOpen || mode === 'File') {
          setStreaming(false);
          return;
        }

        console.log("Camera constraints:", {
          facingMode: 'environment',
          width: { ideal: 1920 },
          height: { ideal: 1080 },
          deviceId: deviceId ? { exact: deviceId } : undefined
        });
  
        // Request new camera access
        const newStream = await navigator.mediaDevices.getUserMedia({
          video: {
            facingMode: 'environment',
            width: { ideal: 1920 },
            height: { ideal: 1080 },
            deviceId: deviceId ? { ideal: deviceId } : undefined
            // deviceId: deviceId ? { exact: deviceId } : undefined
          }
        });
  
        // Double check component is still mounted
        if (!mounted) {
          newStream.getTracks().forEach(track => track.stop());
          return;
        }
  
        if (videoRef.current) {
          videoRef.current.srcObject = newStream;
          stream = newStream;
          setStreaming(true);
          setInitializationAttempts(0); // Reset attempts on success
        } else if (retryCount < MAX_RETRY_ATTEMPTS) {
          // If videoRef isn't ready yet, wait and retry
          await wait(RETRY_DELAY);
          return initializeCamera(retryCount + 1);
        }
      } catch (err) {
        console.error("Error accessing camera:", err);
        if (retryCount < MAX_RETRY_ATTEMPTS) {
          console.log(`Retrying camera initialization (${retryCount + 1}/${MAX_RETRY_ATTEMPTS})`);
          await wait(RETRY_DELAY);
          return initializeCamera(retryCount + 1);
        }
        setStreaming(false);
      }
    };
  
    // Initialize camera
    if (isDrawerOpen && mode !== 'File') {
      initializeCamera();
    }
  
    // Cleanup function
    return () => {
      mounted = false;
      if (stream) {
        stream.getTracks().forEach(track => track.stop());
      }
      if (video?.srcObject) {
        const tracks = video.srcObject.getTracks();
        tracks.forEach(track => track.stop());
      }
    };
  }, [isDrawerOpen, mode, deviceId, refreshCamera]);

  useEffect(() => {
    if (initializationAttempts >= MAX_RETRY_ATTEMPTS) {
      console.error('Failed to initialize camera after maximum retry attempts');
      // You could add additional error handling here
    }
  }, [initializationAttempts]);

  // Separate useEffect for handling mode changes
  useEffect(() => {
    if (forceFileMode) return; // Don't touch media devices if camera is disabled
    if (mode === 'File' && videoRef.current?.srcObject) {
      // Clean up camera when switching to file mode
      const tracks = videoRef.current.srcObject.getTracks();
      tracks.forEach(track => track.stop());
      videoRef.current.srcObject = null;
      setStreaming(false);
    } else if (mode !== '' && mode !== 'File' && !streaming) {
      // Reinitialize camera when switching back from file mode
      navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: 'environment',
          width: { ideal: 1920 },
          height: { ideal: 1080 },
          deviceId: deviceId ? { exact: deviceId } : undefined
        }
      })
      .then((stream) => {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          setStreaming(true);
        }
      })
      .catch((err) => {
        console.error("Error accessing camera:", err);
        setStreaming(false);
      });
    }
  }, [mode, deviceId, streaming, forceFileMode]);

  const capturePhoto = () => {
    console.log('capturePhoto called');
    setModeIsLocked(true);
    const canvas = canvasRef.current;
    const video = videoRef.current;
    const context = canvas.getContext('2d');
  
    // Set canvas dimensions to match the video feed
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
  
    // Draw the current video frame onto the canvas
    context.drawImage(video, 0, 0, canvas.width, canvas.height);
  
    // Save the captured image
    const capturedImage = canvas.toDataURL('image/png');
    console.log('Image captured, base64 length:', capturedImage.length);
    console.log('First 100 chars:', capturedImage.substring(0, 100));
    setImages([...images, capturedImage]);
    
    // Set preview mode without stopping the stream
    setPreviewMode(true);
    if (mode === 'Combine') {
      setShowMultiPictureButtons(true);
    }
  };

  const handleRetakeWithIssue = () => {
    setShowRetakePhotoWithIssue(true);
    setPreviewMode(false);
    setImages([]);
    setUploadingNewReceipt(true);
  }

  const handleRetake = async () => {
    // Reset states without stopping the stream
    setPreviewMode(false);
    setImages(images.slice(0, -1));
  
    // Ensure we have an active stream
    if (!videoRef.current?.srcObject || !streaming) {
      try {
        const newStream = await navigator.mediaDevices.getUserMedia({
          video: {
            facingMode: 'environment',
            width: { ideal: 1920 },
            height: { ideal: 1080 },
            deviceId: deviceId ? { exact: deviceId } : undefined
          }
        });
  
        if (videoRef.current) {
          videoRef.current.srcObject = newStream;
          setStreaming(true);
        }
      } catch (err) {
        console.error("Error restarting camera:", err);
        setStreaming(false);
      }
    }
  };

  const handleKeep = () => {
    setPreviewMode(false);
    if (mode === 'Single') {
      handleDone();
    }
  };

  // const handleDone = async () => {
  //   if (images.length === 0) {
  //     // alert("No images to combine.");
  //     return;
  //   }
  
  //   const combinedImage = await combineImages(images);
  //   setImages([combinedImage]); // Replace multiple images with the combined image
  //   const file = dataURLtoFile(combinedImage, `${uuid()}.png`);
  //   setCombinedImageFile(file);
  //   setShowUploadForm(true);
  //   setUploadingNewReceipt(true);
  // };
  
  // In handleDone function, fix the file extension based on actual format
  const handleDone = async () => {
    console.log('🖼️ handleDone called, images count:', images.length);
    
    if (images.length === 0) {
      console.error('❌ No images to combine');
      return;
    }

    try {
      const combinedImage = await combineImages(images);
      console.log('✅ Combined image created, length:', combinedImage.length);
      
      // Check what format the image actually is
      const isJPEG = combinedImage.startsWith('data:image/jpeg');
      const isPNG = combinedImage.startsWith('data:image/png');
      
      console.log('📄 Combined image format:', {
        isJPEG,
        isPNG,
        mimeType: isJPEG ? 'image/jpeg' : isPNG ? 'image/png' : 'unknown'
      });
      
      // Use correct file extension based on actual format
      const fileExtension = isJPEG ? 'jpg' : 'png';
      const mimeType = isJPEG ? 'image/jpeg' : 'image/png';
      const filename = `${uuid()}.${fileExtension}`;
      
      console.log('Creating file:', {
        filename,
        extension: fileExtension,
        mimeType
      });
      
      let file;
      try {
        file = dataURLtoFile(combinedImage, filename);
        console.log('✅ File created:', {
          name: file.name,
          size: file.size,
          type: file.type,
          expectedType: mimeType
        });
        
        // Verify the file type matches
        if (file.type !== mimeType) {
          console.warn('⚠️ File type mismatch:', {
            actual: file.type,
            expected: mimeType
          });
          
          // Create a new file with correct MIME type
          file = new File([file], filename, { type: mimeType });
          console.log('Fixed file type:', file.type);
        }
      } catch (fileError) {
        console.error('❌ Failed to convert to file:', fileError);
        throw new Error(`Failed to create file: ${fileError.message}`);
      }
      
      setImages([combinedImage]);
      setCombinedImageFile(file);
      setShowUploadForm(true);
      setUploadingNewReceipt(true);
      
    } catch (error) {
      console.error('❌ Error in handleDone:', error);
      alert(`Failed to process images: ${error.message}`);
    }
  };

  const combineImages = async (images) => {
    // Load all images
    const loadedImages = await Promise.all(
      images.map((src) =>
        new Promise((resolve, reject) => {
          const img = new Image();
          img.src = src;
          img.onload = () => resolve(img);
          img.onerror = reject;
        })
      )
    );
  
    // Calculate canvas dimensions
    const totalHeight = loadedImages.reduce((sum, img) => sum + img.height, 0);
    const maxWidth = Math.max(...loadedImages.map((img) => img.width));
  
    // Create canvas and draw images
    const canvas = document.createElement("canvas");
    canvas.width = maxWidth;
    canvas.height = totalHeight;
    const context = canvas.getContext("2d");

    console.log(` ----- Canvas Dimensions: ${canvas.width}x${canvas.height}`);
  
    let yOffset = 0;
    loadedImages.forEach((img) => {
      context.drawImage(img, 0, yOffset);
      yOffset += img.height;
    });
  
    return canvas.toDataURL("image/png"); // Return the combined image as a dataURL
  };

  const dataURLtoFile = (dataURL, filename) => {
    console.log('Converting dataURL to File, dataURL length:', dataURL.length);
    
    if (!dataURL || typeof dataURL !== 'string') {
      console.error('❌ Invalid dataURL');
      throw new Error('Invalid dataURL');
    }
    
    const arr = dataURL.split(",");
    
    if (arr.length < 2) {
      console.error('❌ Malformed dataURL');
      throw new Error('Malformed dataURL');
    }
    
    const mimeMatch = arr[0].match(/:(.*?);/);
    if (!mimeMatch) {
      console.error('❌ Could not extract MIME type from dataURL');
      throw new Error('Could not extract MIME type');
    }
    
    const mime = mimeMatch[1];
    console.log('📄 Detected MIME type:', mime);
    
    try {
      const bstr = atob(arr[1]);
      console.log('📊 Decoded binary string length:', bstr.length);
      
      const u8arr = new Uint8Array(bstr.length);
      for (let i = 0; i < bstr.length; i++) {
        u8arr[i] = bstr.charCodeAt(i);
      }
      
      console.log('Creating File object:', {
        name: filename,
        size: u8arr.length,
        type: mime
      });
      
      const file = new File([u8arr], filename, { type: mime });
      
      // Validate the file
      if (file.size === 0) {
        console.error('❌ Created file is empty');
        throw new Error('Created file is empty');
      }
      
      console.log('✅ File created successfully:', {
        name: file.name,
        size: file.size,
        type: file.type
      });
      
      return file;
    } catch (error) {
      console.error('❌ Error in dataURLtoFile:', error);
      throw new Error(`Failed to convert dataURL to File: ${error.message}`);
    }
  };

  // const dataURLtoFile = (dataURL, filename) => {
  //   const arr = dataURL.split(",");
  //   const mime = arr[0].match(/:(.*?);/)[1];
  //   const bstr = atob(arr[1]);
  //   let n = bstr.length;
  //   const u8arr = new Uint8Array(n);
  //   while (n--) {
  //     u8arr[n] = bstr.charCodeAt(n);
  //   }
  //   return new File([u8arr], filename, { type: mime });
  // };

  const resetForm = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }

    setPreviewMode(false);
    setImages([]);
    setStreaming(false);
    // setFile(null);
    setShowUploadForm(false);
    setShowUploadFormRest(false);

    // const [combinedImageFile, setCombinedImageFile] = useState(null);
    // const [ file, setFile ] = useState(null)

    setFiles([]);
    setPreviews([]);
    setShowUploadForm(false);
    // setImage(null)
    // setMode('Single');
    // setMode('');
    // setFile(null)
    // setImages([]);
    // setStreaming(true);
    // setDevices([]);
    // setSelectedDevice('');
    // setSelectedCamera('');
    // setPreviewMode(false);
    // setShowUploadForm(false);
    setSelectedClient('');
    setValue('selectClient', '');
    setSelectedUnits([]);
    setSelectedDivision('');
    setSelectedClient('');
    setValue('odometer', '');
    setValue('gallons', '');
    setSelectedIFTAUnitOption('');
    setSelectedExpenseCategory('');
    setIsUnitRequired(false);
    isUnitRequiredRef.current = false;
    clearErrors();
  };

  const handleOdometerKeyPress = (e) => {
    // Regular expression for allowed characters (digits and period)
    const allowedChars = /^[0-9.]$/;
    
    if (!allowedChars.test(e.key)) {
      e.preventDefault();
    }
  }

  const handleOdometerChange = (e) => {
    if (e.target.value==='') return
    const miles = stripToNumbersAndDecimal(e.target.value);
    setValue('odometer', miles);
    clearErrors('odometer');
  };

  const handleGallonsKeyPress = (e) => {
    // Regular expression for allowed characters (digits and period)
    const allowedChars = /^[0-9.]$/;
    
    if (!allowedChars.test(e.key)) {
      e.preventDefault();
    }
  }

  const handleGallonsChange = (e) => {
    if (e.target.value==='') return
    const gallons = stripToNumbersAndDecimal(e.target.value);
    setValue('gallons', gallons);
    clearErrors('gallons');
  };  


  const formSubmit = async (values) => {
    // console.log('START formSubmit');
    // console.log('Form values:', JSON.stringify(values, null, 2));
    // console.log('Images count:', images.length);
    // console.log('Combined file exists:', !!combinedImageFile);
    // console.log('Files array:', files?.length || 0);
    // console.log('isEditMode:', isEditMode);
    // console.log('uploadingNewReceipt:', uploadingNewReceipt);

    // // Admin flow verification
    // console.log('targetTeamMemberId (cardholder):', targetTeamMemberId);
    // console.log('currentTeamMemberId (admin):', currentTeamMemberId);
    // console.log('effectiveActionType:', effectiveActionType);
    // console.log('attachReceiptParams:', JSON.stringify(attachReceiptParams, null, 2));
    // console.log('plaidCreditCardTransactionId:', plaidCreditCardTransactionId);
    // console.log('qbEnv / allSort will be:', qbEnv === 'sandbox' ? 'sandbox' : 'all');

    // return; // TEMPORARY - remove after debugging

    logStep('FORM_SUBMITTED', {
      imageCount:          images.length,
      hasFiles:            !!(files?.length > 0),
      fileCount:           files?.length || 0,
      isEditMode,
      effectiveActionType,
    });

    // Determine if this is a manual upload.
    // ⚠️ Must be declared here — before any block that references it — to avoid
    // a Temporal Dead Zone ReferenceError that would silently kill formSubmit.
    const isManualUpload = effectiveActionType === 'preemptive' || isNotificationExpired;
    // console.log('✅ isManualUpload evaluated successfully:', isManualUpload, '| effectiveActionType:', effectiveActionType);

    // For non-instant-notification paths (manual/preemptive), fall back to the
    // receipt table check, but filter out rolled-back (deleted) receipts.
    if (attachReceiptParams?.hasIssue !== true && hasInstantNotification && instantNotificationId) {
      if (!externallyOpened) {
        // Non-link path: check receipt table but ignore deleted/rolled-back records
        try {
          const existingReceipts = await fetchCapitalOneReceiptByInstantNotificationId(instantNotificationId);
          const validReceipts = existingReceipts?.filter(r => r.matchStatus !== 'deleted') || [];
          if (validReceipts.length > 0) {
            setConfirmationModalHeaderText('Already Submitted');
            setConfirmationModalContent('A receipt has already been uploaded using this instant notification.');
            setShowConfirmationModal(true);
            onConfirmModalOpen();
            return;
          }
        } catch (error) {
          console.error('Error during final instant notification validation:', error);
          setConfirmationModalHeaderText('Error');
          setConfirmationModalContent('There was an error validating the instant notification. Please try again or contact support.');
          setShowConfirmationModal(true);
          return;
        }
      }
      // externallyOpened path: already gated by checkTransactions() +
      // the "pending" write above — safe to continue.
    }

    // Mark the instant notification as pending (in-progress) before anything starts.
    // If the browser is force-closed at any point after this, the notification
    // will be in 'pending' state which allows the cardholder to retry.
    if (hasInstantNotification && instantNotificationId && externallyOpened && !isManualUpload) {
      try {
        console.log('Marking instant notification as pending (in-progress)');
        await updateInstantNotification({
          id: instantNotificationId,
          allSort: 'all',
          status: 'pending',
          isSubmitted: false,
        });
        console.log('Instant notification marked as pending');
        logStep('PENDING_MARKED');
      } catch (pendingMarkError) {
        console.warn('Could not mark notification as pending (non-fatal):', pendingMarkError);
      }
    }

    // Open submission modal
    onSubmitModalOpen();
    setSubmitModalContent('Starting upload process...');
    setSubmissionProgress(5);
    setSubmitModalCloseDisabled(true);

    const transactionManager = new TransactionManager();
    let receiptId = '';
    let uploadedDocuments = [];

    try {

      // Use existing receipt ID for edit mode or generate new one
      receiptId = isEditMode ? transactionData.capitalOneCreditCardTransactionReceiptId : uuid();

      // Step 1: Prepare statement parameters
      const statementParams = {
        id: receiptId,
        allSort: "all",
        isReceiptUploaded: true,
        addedNotes: values?.addedNotes || '', // Ensure empty string if undefined
        divisionId: values.selectDivision.value,
        ...((values.selectClient !== "" && values.selectClient !== "none" && values.selectClient?.value !== "" && values.selectClient?.value !== "none") && { clientId: values.selectClient }),
        // teamMemberId: currentTeamMemberId,
        teamMemberId: targetTeamMemberId || currentTeamMemberId,
        ...(values.selectExpenseCategory && { expenseCategoryId: values?.selectExpenseCategory }),
        transactionType: values.selectStatementType || 'receipt',
        matchStatus: "preemptive" // Default value
      };

      // Set match status based on action type
      if (effectiveActionType === 'upload-with-transaction') {
        statementParams.matchStatus = "with-transaction-admin";
      } else if (effectiveActionType === 'fix-issue') {
        statementParams.matchStatus = "fixed-issue";
        statementParams.issue = values?.updateReceiptIssue;
      } else if (!isManualUpload) {
        statementParams.matchStatus = "with-notification";
      } else {
        if (values?.selectStatementType === 'invoice') {
          statementParams.matchStatus = targetTeamMemberId ? "preemptive-invoice-admin" : "preemptive-invoice";
        } else if (values?.selectStatementType === 'refund') {
          statementParams.matchStatus = targetTeamMemberId ? "preemptive-refund-admin" : "preemptive-refund";
        } else {
          statementParams.matchStatus = targetTeamMemberId ? "preemptive-admin" : "preemptive";
        }
      }

      if (hasInstantNotification) {
        statementParams.capitalOneInstantNotificationId = instantNotificationId;
      }

      if (plaidCreditCardTransactionId) {
        statementParams.plaidCreditCardTransactionId = plaidCreditCardTransactionId;
      }

      console.log('Final statementParams:', {
        ...statementParams,
        matchStatus: statementParams.matchStatus
      });

      console.log('statementParams: ', statementParams);
      console.log('Setting matchStatus:', {
        effectiveActionType,
        isManualUpload,
        isNotificationExpired,
        selectStatementType: values.selectStatementType,
        matchStatus: statementParams.matchStatus
      });

      

      if (combinedImageFile || files || (isEditMode && uploadingNewReceipt)) {
        console.log('Adding upload operation to transaction manager');
        // Step 1: FIRST upload files and collect uploaded documents
        transactionManager.addOperation(new DatabaseOperation(
          async () => {
            console.log('📤 Starting file upload operation');
            setSubmitModalContent('Uploading receipt image...');
            setSubmissionProgress(30);

            // Slow progress ticker — increments 30→50% while S3 upload is running.
            // Gives the cardholder visual confirmation that the process is alive,
            // especially on slow mobile connections where this step can take 15-30s.
            let tickProgress = 30;
            let tickCount = 0;
            const progressTicker = setInterval(() => {
              tickCount++;
              tickProgress = Math.min(tickProgress + 1, 49);
              setSubmissionProgress(tickProgress);

              if (tickCount >= 17) {
                // ~15 seconds in — escalate to slow-connection reassurance
                setSubmitModalContent('Still uploading — slow connections can take up to a minute. Don\'t close this window.');
              } else if (tickProgress % 6 === 0) {
                setSubmitModalContent('Uploading receipt image — please keep this window open...');
              } else if (tickProgress % 6 === 3) {
                setSubmitModalContent('Uploading receipt image...');
              }
            }, 900);

            try {
              if (combinedImageFile) {
                logStep('S3_UPLOAD_STARTED', {
                  fileName: combinedImageFile.name,
                  fileSize: combinedImageFile.size,
                  fileType: combinedImageFile.type,
                });
                console.log('📤 Uploading combined file:', combinedImageFile.name);
                const uploadedDocument = await uploadWithTimeout(() => withRetry(() => uploadStatement(combinedImageFile)));
                console.log('✅ Combined file uploaded:', uploadedDocument);
                uploadedDocuments.push(uploadedDocument);
              } else if (files && files.length > 0) {
                console.log('📤 Uploading files array, count:', files.length);
                logStep('S3_UPLOAD_STARTED', {
                  fileCount: files.length,
                  fileSize:  files.reduce((sum, f) => sum + f.size, 0),
                });
                
                const docs = await withRetry(() => Promise.all(
                  files.map(async (file) => {
                    console.log(`📤 Uploading file: ${file.name} (${file.size} bytes)`);
                    const uploadResult = await uploadWithTimeout(() => uploadStatement(file));
                    console.log(`✅ Uploaded:`, uploadResult);
                    return uploadResult;
                  })
                ));
                
                console.log('✅ All files uploaded:', docs);
                
                const validDocs = docs.filter(doc => doc && doc.documentId);
                console.log('✅ Valid documents:', validDocs);
                
                if (validDocs.length === 0) {
                  throw new Error('No valid documents were uploaded');
                }
                
                uploadedDocuments.push(...validDocs);
              }
            } finally {
              // Always clear the ticker — whether upload succeeded or failed
              clearInterval(progressTicker);
            }

            console.log('📝 Uploaded documents collected:', {
              count: uploadedDocuments.length,
              documents: uploadedDocuments
            });

            logStep('S3_UPLOAD_COMPLETE', {
              documentCount: uploadedDocuments.length,
              documentId:    uploadedDocuments[0]?.documentId || null,
            });
            
            return uploadedDocuments;
          },
          async () => {
            console.warn('File uploads completed but transaction failed. Files may need manual cleanup:', uploadedDocuments);
          }
        ));
      }

      // Step 3: Handle IFTA Tracking
      if (isIFTATracked) {
        const iftaTrackingJSON = {
          allSort: 'all',
          transactionId: receiptId,
          unitId: selectedIFTAUnitOption?.value,
          teamMemberId: currentTeamMemberId,
          stateTwoChar: values?.selectState?.value,
          gallons: values?.gallons,
          odometer: values?.odometer,
        };

        transactionManager.addOperation(new DatabaseOperation(
          async () => {
            setSubmitModalContent('Creating IFTA tracking...');
            setSubmissionProgress(45);
            const iftaFuelTaxTrackId = await withRetry(() => addIFTAFuelTracking(iftaTrackingJSON));
            statementParams.iftaFuelTaxTrackId = iftaFuelTaxTrackId;
            return iftaFuelTaxTrackId;
          },
          async (iftaId) => {
            // Rollback IFTA tracking by marking as inactive
            if (iftaId) {
              await updateIFTAActiveStatus({ id: iftaId, isActive: false });
            }
          }
        ));
      }

      // Step 4: Create or update receipt
      transactionManager.addOperation(new DatabaseOperation(
        async () => {
          // setSubmitModalContent(isEditMode ? 'Updating receipt...' : 'Creating receipt...');
          setSubmitModalContent(isEditMode ? 'Saving receipt details...' : 'Saving receipt record...');
          setSubmissionProgress(55);
          
          console.log('Starting receipt creation process...');
          console.log('Receipt params:', {
            ...statementParams,
            matchStatus: statementParams.matchStatus || 'preemptive'
          });
          
          let finalReceiptId = receiptId;
          
          try {
            if (isEditMode && !isManualUpload) {
              // Update existing receipt
              console.log('Updating existing receipt for transaction:', creditCardTransactionId);
              
              if (creditCardTransactionId) {
                const params = {
                  id: creditCardTransactionId,
                  capitalOneCreditCardTransactionReceiptId: receiptId
                };
                if (instantNotificationId) {
                  params.capitalOneInstantNotificationId = instantNotificationId;
                }
                console.log('📝 Updating transaction link:', params);
                const updateResult = await withRetry(() => updateTransaction(params));
                console.log('✅ Transaction link updated:', updateResult);
              }
              
              console.log('📝 Updating receipt details:', statementParams);
              const updateReceiptResultId = await withRetry(() => updateCreditCardTransactionReceipt(statementParams));
              console.log('✅ Receipt details updated:', updateReceiptResultId);
              finalReceiptId = updateReceiptResultId;
            } else {
              // Create new receipt
              console.log('🆕 Creating new receipt with params:', {
                ...statementParams,
                matchStatus: statementParams.matchStatus || 'preemptive'
              });
              
              // Ensure we have all required fields
              const receiptCreationParams = {
                ...statementParams,
                matchStatus: statementParams.matchStatus || 'preemptive',
                // Ensure these are explicitly set if they might be undefined
                addedNotes: statementParams.addedNotes || '',
                divisionId: statementParams.divisionId,
                teamMemberId: statementParams.teamMemberId,
                transactionType: statementParams.transactionType || 'receipt',
                isReceiptUploaded: true
              };
              
              console.log('Calling createCapitalOneReceipt with:', receiptCreationParams);
              const newReceiptId = await withRetry(() => createCapitalOneReceipt(receiptCreationParams));
              console.log('✅ Receipt created with ID:', newReceiptId);
              finalReceiptId = newReceiptId;
              
              if (creditCardTransactionId) {
                const params = {
                  id: creditCardTransactionId,
                  capitalOneCreditCardTransactionReceiptId: newReceiptId,
                };
                if (instantNotificationId) {
                  params.capitalOneInstantNotificationId = instantNotificationId;
                }
                console.log('Linking receipt to transaction:', params);
                const updateResult = await withRetry(() => updateTransaction(params));
                console.log('✅ Receipt linked to transaction:', updateResult);
              }
            }
            
            console.log('🎉 Receipt process completed. Final receipt ID:', finalReceiptId);
            logStep('RECEIPT_CREATED', {
              receiptId:   finalReceiptId,
              matchStatus: statementParams.matchStatus,
              isEditMode,
            });
            return finalReceiptId;
          } catch (error) {
            console.error('❌ Error in receipt creation process:', {
              message: error.message,
              stack: error.stack,
              isEditMode,
              isManualUpload,
              receiptId,
              statementParams
            });
            throw new Error(`Failed to create/update receipt: ${error.message}`);
          }
        },
        async (createdReceiptId) => {
          // Rollback receipt creation by marking as deleted
          console.log('Attempting receipt rollback for ID:', createdReceiptId);
          if (createdReceiptId && !isEditMode) {
            try {
              await updateCreditCardTransactionReceipt({
                id: createdReceiptId,
                matchStatus: 'deleted'
              });
              console.log('✅ Receipt marked as deleted for rollback');
            } catch (rollbackError) {
              console.error('❌ Failed to rollback receipt:', rollbackError);
            }
          }
        }
      ));

      // Step 5: Link uploaded documents to receipt
      transactionManager.addOperation(new DatabaseOperation(
        async () => {
          console.log('[DEBUG] Document linking debug AT EXECUTION:', {
            receiptId,
            uploadedDocuments,
            uploadedDocumentsCount: uploadedDocuments.length,
            hasDocumentLinkOperation: uploadedDocuments.length > 0
          });

          if (uploadedDocuments.length === 0) {
            console.warn('[DEBUG] No documents to link at execution time');
            return [];
          }

          console.log('[DEBUG] ACTUALLY linking documents now');
          setSubmitModalContent('Linking receipt image...');
          setSubmissionProgress(70);

          console.log('[DEBUG] Documents to link:', {
            receiptId,
            uploadedDocumentsCount: uploadedDocuments.length,
            documentIds: uploadedDocuments.map(d => d?.documentId),
            urls: uploadedDocuments.map(d => d?.url)
          });

          const linkPromises = uploadedDocuments.map((uploadedDocument, index) => {
            console.log(`[DEBUG] Creating link #${index + 1} for document:`, {
              documentId: uploadedDocument?.documentId,
              url: uploadedDocument?.url,
              receiptId
            });

            if (!uploadedDocument?.documentId) {
              console.error('❌ [DEBUG] Invalid uploaded document:', uploadedDocument);
              throw new Error('Uploaded document is missing documentId');
            }

            const linkParams = {
              receiptId,
              uploadedDocumentId: uploadedDocument.documentId
            };

            console.log('[DEBUG] Calling addStatementDocumentLink with:', linkParams);

            return withRetry(() => addStatementDocumentLink(linkParams));
          });

          const linkResults = await Promise.all(linkPromises);
          console.log('✅ [DEBUG] Document links created:', linkResults);
          logStep('DOCUMENTS_LINKED', {
            documentCount: linkResults.length,
            receiptId,
          });
          return linkResults;
        },
        async (linkIds) => {
          console.warn('[DEBUG] Document links would need rollback', linkIds);
        }
      ));

      // Step 5: Update instant notification if needed
      if (!isManualUpload && externallyOpened) {
        transactionManager.addOperation(new DatabaseOperation(
          async () => {
            setSubmitModalContent('Updating notification status...');
            setSubmissionProgress(85);
            
            const updateParams = {
              id: transactionId,
              allSort: 'all',
              capitalOneCreditCardTransactionReceiptId: receiptId,
              isSubmitted: true,
              status: receiptHasIssue ? "fixed-issue" : "has-receipt",
            };
            logStep('NOTIFICATION_UPDATED', {
              notificationFinalStatus: updateParams.status,
            });
            return await withRetry(() => updateInstantNotification(updateParams));
          },
          async () => {
            // Rollback notification update
            await updateInstantNotification({
              id: transactionId,
              allSort: 'all',
              isSubmitted: false,
              status: 'pending'
            });
          }
        ));
      }

      // Step 6: Add unit records
      if (selectedUnits.length > 0 && !isIFTATracked) {
        transactionManager.addOperation(new DatabaseOperation(
          async () => {
            setSubmitModalContent('Adding unit assignments...');
            setSubmissionProgress(90);
            
            const unitPromises = selectedUnits.map(unit => {
              const unitParams = {
                unitId: unit.value,
                transactionId: receiptId,
              };
              return withRetry(() => addStatementDocumentUnit(unitParams));
            });
            const unitResults = await Promise.all(unitPromises);
            logStep('UNITS_ADDED', {
              unitCount: selectedUnits.length,
            });
            return unitResults;
            // return await Promise.all(unitPromises);
          },
          // async (unitRecords) => {
          //   // Rollback unit assignments - log for manual cleanup
          //   console.warn('Unit assignments created but transaction failed. May need manual cleanup.');
          // }
        ));
      }

      // Execute all operations transactionally
      console.log('Starting transaction manager execution');
      await transactionManager.execute();
      console.log('✅ Transaction manager execution completed');

      console.log('Transaction manager execution completed successfully');
      console.log('Final state:', {
        receiptId,
        uploadedDocumentsCount: uploadedDocuments.length,
        submissionProgress,
        isReceiptUploaded
      });

      // Success - update UI
      console.log('1️Transaction manager completed');
      logStep('UPLOAD_COMPLETE', {
        receiptId,
        documentCount: uploadedDocuments.length,
      });
      setSubmissionProgress(100);
      console.log('2️Progress set to 100');
      setIsReceiptUploaded(true);
      console.log('3️isReceiptUploaded set to true');
      triggerConfetti();
      console.log('4️Confetti triggered');
      setSubmitModalCloseDisabled(false);

    } catch (error) {
      console.error('Transaction manager execution failed:', error);
      logStep('UPLOAD_FAILED', {
        errorMessage: error.message,
        errorStep: error.message.includes('timed out') ? 'S3_UPLOAD_TIMEOUT' : 'transaction-manager',
      });
      console.error('Error stack:', error.stack);
      
      // Error handling
      // {/* <AvailableIcons boxSize={'35px'} color={'var(--error-red)'} iconRef={'alert'} /> */}
      setSubmitModalContent(`Upload failed: ${error.message}`);
      setSubmissionProgress(0);
      setSubmitModalCloseDisabled(false);

      setConfirmationModalHeaderText("Upload Failed");

      setConfirmationModalIcon("alert"); // whatever your red alert icon is
      setConfirmationModalIconColor("var(--error-red)");

      setConfirmationModalContent(
        <>
          Your receipt didn’t upload. <Text as="b" display="inline">Keep your receipt</Text> and try again when you have a better connection.
        </>
      );
      // setConfirmationModalContent(
      //   <>
      //     Your receipt didn’t upload. <Text as="b" display="inline">Keep your receipt</Text> and try again when you have a better connection.
      //     <br />
      //     <br />
      //     Use your instant notification link to resubmit, or upload again from My Receipts.
      //   </>
      // );
      setShowConfirmationModal(true);
      onConfirmModalOpen();
    }
    // setShowConfirmationModal(true);
    // onConfirmModalOpen();
  };
  
  async function uploadStatement(file) {
    console.log('uploadStatement called');
    console.log('File details:', {
      name: file.name,
      size: file.size,
      type: file.type,
      lastModified: file.lastModified
    });

    // Check if file is valid
    if (!file || file.size === 0) {
      console.error('File is invalid or empty');
      throw new Error('File is invalid or empty');
    }

    // Check if file is readable
    try {
      const arrayBuffer = await file.arrayBuffer();
      console.log('File is readable, arrayBuffer size:', arrayBuffer.byteLength);
      
      // Quick check for image validity
      if (file.type.startsWith('image/')) {
        const img = new Image();
        const imgLoadPromise = new Promise((resolve, reject) => {
          img.onload = () => {
            console.log('✅ Image loads successfully:', {
              width: img.width,
              height: img.height
            });
            resolve(true);
          };
          img.onerror = () => {
            console.error('❌ Image failed to load - likely corrupted');
            reject(new Error('Image file appears to be corrupted'));
          };
        });
        
        const objectURL = URL.createObjectURL(file);
        img.src = objectURL;
        
        // Wait a short time for image to load
        await Promise.race([
          imgLoadPromise,
          new Promise((_, reject) => 
            setTimeout(() => reject(new Error('Image load timeout')), 3000)
          )
        ]);
        
        URL.revokeObjectURL(objectURL);
      }
    } catch (validationError) {
      console.error('❌ File validation failed:', validationError);
      throw new Error(`File validation failed: ${validationError.message}`);
    }
    
    // Determine bucket based on environment
    const userBucket = import.meta.env.VITE_S3_STATEMENT_BUCKET;
    console.log('Using S3 bucket:', userBucket);

    console.log('[RECEIPT] Starting upload for:', file.name);

    try {
      // Use new upload function with proper error handling
      console.log('Before calling uploadStatementToS3');
      const uploadData = await uploadStatementToS3({ 
        file: file, 
        bucket: userBucket,
        filename: file.name,
        filetype: file.type
      });
      
      console.log('✅ [RECEIPT] Upload successful:', uploadData);
      console.log('✅ Upload data structure:', {
        hasDocumentId: !!uploadData?.documentId,
        hasKey: !!uploadData?.key,
        hasUrl: !!uploadData?.url
      });
      
      return uploadData;

    } catch (error) {
      console.error('❌ [RECEIPT] Upload failed with error:', error);
      console.error('❌ Error name:', error.name);
      console.error('❌ Error message:', error.message);
      console.error('❌ Error stack:', error.stack);

      // Re-throw with context
      throw new Error(`Failed to upload receipt: ${error.message}`);
    }
  }

  const handleModeChange = (newMode) => {
    setMode(newMode);
  
    if (newMode === 'File') {
      // Try multiple scroll approaches
      if (containerRef.current) {
        containerRef.current.scrollTop = 0;
      }
      
      // Also try scrolling the parent elements
      const drawer = document.querySelector('.chakra-modal__content');
      if (drawer) {
        drawer.scrollTop = 0;
      }

      // Force scroll after a small delay to ensure DOM is updated
      setTimeout(() => {
        window.scrollTo(0, 0);
        // Focus the file input
        if (fileInputRef.current) {
          fileInputRef.current.focus();
        }
      }, 100);
    }
  };

  useEffect(() => {
    if (mode !== '' && mode !== 'File') {
      // console.log('Starting camera mode...');
      setPreviewMode(false); // Reset preview if switching to camera mode
    } else if (mode === 'File') {
      // console.log('Switching to file upload mode...');
      // Clean up webcam if switching to file mode
      const video = webcamRef.current;
      if (video && video.srcObject) {
        video.srcObject.getTracks().forEach(track => track.stop());
        video.srcObject = null;
      }
    }
  }, [mode]);

  const [files, setFiles] = useState([]);
  const [previews, setPreviews] = useState([]);  // Array to hold preview images

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files); // Convert FileList to array
    setFiles(selectedFiles);

    // Generate previews for each selected file
    const previewPromises = selectedFiles.map(file => generatePreview(file));

    // Wait for all previews to be generated
    Promise.all(previewPromises).then(previewImages => {
      setPreviews(previewImages);  // Update state with all previews
    });
    if (selectedFiles.length > 0) {
      setShowUploadForm(true);
    }
  };

  const generatePreview = async (file) => {
    if (file.type.startsWith("image/")) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result);  // Resolve with the image URL
        };
        reader.readAsDataURL(file);
      });
    } else if (file.type === "application/pdf") {
      return generatePdfPreview(file);
    }
    return null;
  };

  const generatePdfPreview = async (pdfFile) => {
    const fileReader = new FileReader();
    return new Promise((resolve) => {
      fileReader.onload = async function () {
        const typedarray = new Uint8Array(this.result);

        const loadingTask = pdfjsLib.getDocument(typedarray);
        const pdf = await loadingTask.promise;

        // Get the first page of the PDF
        const page = await pdf.getPage(1);

        // Set up a canvas for rendering
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        const viewport = page.getViewport({ scale: 0.5 });

        canvas.height = viewport.height;
        canvas.width = viewport.width;

        await page.render({
          canvasContext: context,
          viewport: viewport,
        }).promise;

        // Convert canvas to data URL and resolve it
        resolve(canvas.toDataURL());
      };

      fileReader.readAsArrayBuffer(pdfFile);
    });
  };

  const handleClose = async () => {
    reset();
    setIsDrawerOpen(false);
    
    // Stop video tracks with a small delay to ensure proper cleanup
    if (videoRef.current?.srcObject) {
      const tracks = videoRef.current.srcObject.getTracks();
      await Promise.all(tracks.map(track => {
        return new Promise(resolve => {
          track.stop();
          resolve();
        });
      }));
      videoRef.current.srcObject = null;
    }

    props = null;
  
    // Reset all states
    setIsEditMode(false);
    setIsAlreadyUploaded(false);
    setIsNotificationExpired(false);
    setReceiptIssueLog('');
    setReceiptHasIssue(false);
    setShowRetakePhotoWithIssue(false);
    setUploadingNewReceipt(false);
    setIsReceiptUploaded(false);
    setEffectiveActionType(null);
    setTransactionData(null);

    setStreaming(false);
    setInitializationAttempts(0);
    setMode('');
    setImages([]);
    setPreviewMode(false);
    setShowUploadForm(false);
    setDeviceId(null);
    setShowMultiPictureButtons(false);
    setModeIsLocked(false);
    setFiles(null);
    setPreviews([]);
    setCombinedImageFile(null);
    setUnitOptions([]);
    setIFTAUnitOptions([]);
    setSelectedIFTAUnitOption([]);
    setSelectedUnits([]);
    setSelectedDivision('');
    setSelectedClient('');
    setValue('odometer', '');
    setValue('gallons', '');
    setSelectedExpenseCategory('');
    setIsUnitRequired(false);
    isUnitRequiredRef.current = false;
    clearErrors();
    
    onClose();
  };
  
  // Add useEffect to handle drawer opening
  useEffect(() => {
    setIsDrawerOpen(true);
  }, []); // Run once on mount to set initial state

  const startCamera = () => {
    setShowMultiPictureButtons(false);
    handleRefreshCamera();
  }

  return (

<>
      <Container ref={containerRef} as="form" onSubmit={handleSubmit(formSubmit, onError)}>

        <div>
          {/* Button to trigger confetti */}
          {/* <button type="button" onClick={triggerConfetti}>Launch Drawer Confetti</button> */}
          
          {/* Drawer with canvas for confetti */}
          <div>
            <canvas
              ref={canvasRef}
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 1000,
                pointerEvents: 'none',
              }}
            />
          </div>
        </div>

        {(isAlreadyUploaded===false || isEditMode===true) && (
          <>
            <Flex
              direction="column"
              maxW="800px"
              mx="auto"
              color="white"
              minH="100vh"
            >
              <Box>
                <Flex direction="row" alignItems="flex-start" justifyContent="space-between">
                  {/* Left Container */}
                  <Box>
                    <Text as="span" textStyle="heading-1">{(receiptHasIssue || selectedActionType==='edit') ? "Edit Receipt" : "Upload Receipt"}</Text>
                  </Box>

                  {/* Spacer between Left and Right Content */}
                  <Spacer />

                  {/* Right Container - Button */}
                  <Box>
                    {/* {!externallyOpened && ( */}
                    {(!externallyOpened || showCancel) && (
                      <ResponsiveCancelCloseButton 
                        iconSize={['22px', '26px']}
                        isMobile={isMobile}
                        value="Cancel"
                        onClick={handleClose} />
                    )}
                  </Box>
                </Flex>

                

                {selectedActionType==='edit' && (<>
                  <Box paddingY={'25px'}  display="flex" justifyContent="center" alignItems="center">
                    <ButtonQuaternaryPlain
                      type='button'
                      name='retake-with-issue'
                      value='Retake Receipt Photo'
                      onClick={handleRetakeWithIssue}
                      w='220px'
                    />
                  </Box>
                  </>
                )}

                {receiptHasIssue && (<>

                  <Box paddingY={'25px'}  display="flex" justifyContent="center" alignItems="center">
                    <ButtonQuaternaryPlain
                      type='button'
                      name='retake-with-issue'
                      value='Retake Receipt Photo'
                      onClick={handleRetakeWithIssue}
                      w='220px'
                    />
                  </Box>

                  <Box>
                    <Text as="span" textStyle="label-2" display="block" mt="4px" marginRight={'10px'}>Reason for return: </Text>
                    <Text
                      paddingLeft="25px"
                      as="span"
                      textStyle="label-2"
                      display="block"
                      mt="4px"
                    >
                      {receiptIssueLog.split('::cr::').map((line, index) => (
                        <Box key={index}>
                          {line}
                          {index < receiptIssueLog.split('::cr::').length - 1 && <br />}
                        </Box>
                      ))}
                    </Text>
                  </Box>
                        
                  <Box pl={'25px'} pt={'25px'}>
                    <TextareaInput
                      fieldname="receiptIssue"
                      prettyname="Receipt Issue"
                      register={register}
                      errors={errors}
                      placeholder="Response to the issue is required."
                      isRequired={true}
                      isReadOnly={false}
                      rows={2}
                      onChange={(e) => {
                        handleUpdateReceiptIssue(e.target.value);
                      }}
                    />
                  </Box>

                  </>
                )}

                {priorAttemptFailed && (
                  <Box
                    bg="var(--warning-yellow, #FFF3CD)"
                    border="1px solid var(--warning-border, #FFCA28)"
                    borderRadius="8px"
                    p={4}
                    mb={4}
                  >
                    <Text fontWeight="bold" color="var(--warning-text, #856404)">
                      Previous Upload May Not Have Completed
                    </Text>
                    <Text fontSize="sm" color="var(--warning-text, #856404)" mt={1}>
                      Your last upload attempt did not confirm successfully — this may be due to
                      a poor connection. Please try again.
                    </Text>
                  </Box>
                )}

                {(!receiptHasIssue && selectedActionType==='upload-with-transaction') && (<>
                  <Text as="span" textStyle="label-2" display="block" mt="4px">
                    {transactionData?.merchantEntityName}
                  </Text>
                  <Text as="span" textStyle="label-2" display="block" mt="4px">
                    {(transactionData?.date) && spellOutDate(transactionData?.date, 'apple-fy')}
                  </Text>
                  <Text as="span" textStyle="label-2" display="block" mt="4px">
                    {transactionData?.amount}
                  </Text></>
                )}
                {(!receiptHasIssue && selectedActionType==='preemptive') && (
                  <Text as="span" textStyle="label-2" display="block" mt="4px">
                    {/* This should be standard preemptive, not missing transaction */}
                    {/* Add receipt for missing transaction */}
                    Upload receipt.
                  </Text>
                )}
                {(!receiptHasIssue && transactionData?.purchaseMerchant && selectedActionType!=='preemptive') && (
                  <Text as="span" textStyle="label-2" display="block" mt="4px">
                    {transactionData?.purchaseMerchant} ${transactionData?.purchaseAmount}
                  </Text>
                )}
                {(!receiptHasIssue && !transactionData?.purchaseMerchant && attachReceiptParams?.name && selectedActionType!=='preemptive') && (
                  <Text as="span" textStyle="label-2" display="block" mt="4px">
                    {attachReceiptParams?.name} ${attachReceiptParams?.amount}
                  </Text>
                )}

                {((showRetakePhotoWithIssue && receiptHasIssue) || !receiptHasIssue) && <Box>
                  <VStack spacing={4}>
                    <>
                      {/* {(isEditMode && !editModeIsLocked) && (<>
                        <ButtonPrimaryPlain
                          type='button'
                          name='replaceReceipt'
                          value='Replace Receipt'
                          onClick={handleShowReplaceReceipt(true)}
                        />
                        <ButtonPrimaryPlain
                          type='button'
                          name='keepReceipt'
                          value='Edit Details'
                          onClick={handleShowReplaceReceipt(false)}
                        />
                      </>)} */}
                      
                      {images?.length > 0 && (
                        <Box>
                          {images.map((image, index) => (
                            <ChakraImage key={index} src={image} alt={`Receipt ${index + 1}`} />
                          ))}
                          {images.length > 0 && previewMode && (
                            <Flex direction="column" align="center" w="100%">
                              <Flex 
                                justify="space-between"
                                align="center"
                                w={'90%'}
                                my={'25px'}
                                mx={'auto'}
                              >
                                <ButtonQuaternaryPlain
                                  type='button'
                                  name='retake'
                                  value='Retake'
                                  onClick={handleRetake}
                                  w='45%'
                                />
                                <ButtonPrimaryPlain
                                  // mx={'20px'}
                                  type="button"
                                  onClick={handleKeep}
                                  name="keep"
                                  value="Keep"
                                  w='45%'
                                />
                              </Flex>
                            </Flex>
                          )}
                        </Box>
                      )}

                      {/* If selectedActionType = preemptive we need to allow them to select an image from the 
                          receipt uploads that did not have an instant notification. */}

                      {(mode==='File') && (
                        <>
                          <Flex wrap="wrap" mt={4}>
                            {previews.map((preview, index) => (
                              <Box key={index} m={2}>
                                <img src={preview} alt={`Preview ${index + 1}`} width="200px" />
                              </Box>
                            ))}
                          </Flex>
                          <Box>
                            <Text as="span" textStyle='label-2'>Upload PDF or Image</Text>
                            {/* <Input type="file" accept="image/*" capture="environment"></Input> */}
                            <Input 
                              name='fileUpload'
                              id='fileUpload'
                              paddingTop={'6px'} 
                              paddingLeft={'8px'} 
                              placeholder='Choose File(s)' 
                              type="file" 
                              accept="image/jpeg, image/jpg, image/png, application/pdf"
                              // accept=".jpg, .jpeg, .png, image/jpeg, image/png"
                              multiple
                              onChange={handleFileChange}
                              // capture="environment"
                              ref={fileInputRef} />
                          </Box>
                        </>
                      )}

                      {showMultiPictureButtons && 
                        <>
                          {images.length > 0 && !previewMode && mode === 'Combine' && !showUploadForm && (
                            <ButtonPrimaryPlain
                              // mx={'20px'}
                              type="button"
                              // onClick={startCamera}
                              onClick={startCamera}
                              name="continue"
                              value="Take another picture"
                            />
                          )}
                          {showMultiPictureButtons && !previewMode && !showUploadForm && (
                            <ButtonQuaternaryPlain
                              type='button'
                              name='done'
                              value='I am done taking pictures'
                              onClick={handleDone}
                            />
                          )}
                        </>
                      }

                      {(!showUploadForm && mode!=='File') && <>
                        <Box display="flex" flexDirection="column" alignItems="center" width="100%">

                          {(!previewMode && !showMultiPictureButtons) && (
                            <>
                              {/* Camera Selection Dropdown */}
                              {/* {devices.length > 1 && ( */}
                              <Box mb={4} width="100%">
                                <FormSelectSimple
                                  register={register}
                                  control={control}
                                  errors={errors}
                                  onChange={(e) => {
                                    console.log(devices);
                                    setDeviceId(e.value);
                                  }}
                                  selectedoption={devices.find(device => device.deviceId === deviceId)}
                                  optionsArray={devices?.map(( device, index ) => ({
                                    label: device.label || `Camera ${index + 1}`,
                                    value: device.deviceId,
                                    key: device.deviceId
                                  }))}
                                  fieldname='seletCamera'
                                  prettyname='Select Camera'
                                  fieldlabel={`Select Camera (${devices.length})`}
                                  placeholder={'Select camera'}
                                  issearchable={false}
                                />
                              </Box>
                              {/* )} */}

                              {/* Video Display */}
                              <Box width="100%" position="relative">
                                <Box>
                                  <video
                                    autoPlay={true} 
                                    playsInline={true} 
                                    muted={true}
                                    ref={videoRef}
                                    // autoPlay
                                    // playsInline
                                    style={{ maxWidth: '100%', height: 'auto' }} // Responsive styling
                                  />
                                  
                                  {/* Hidden canvas used for capturing images */}
                                  <canvas ref={canvasRef} style={{ display: 'none' }} />
                                  {/* <Webcam
                                    audio={false}
                                    ref={webcamRef}
                                    screenshotQuality={1}
                                    // screenshotFormat="image/jpeg"
                                    screenshotFormat="image/png"
                                    videoConstraints={videoConstraints}
                                    style={mode !== 'File' ? { width: '100%', height: 'auto' } : { width: '0px', height: '0px' }}
                                    // onLoadedMetadata={() => setIsVideoLoaded(true)}
                                  /> */}
                                </Box>
                              </Box>
                            </>
                          )}

                          {(!previewMode && !showUploadForm && mode!=='File') && (
                            <>
                              <Flex direction="column" align="center" w="100%">
                              {!previewMode && images?.length===0 && (
                                <Flex justify="space-between" align="center" w={'90%'} mt={'25px'}>
                                  {/* Left-aligned upload button isSupervisor */}
                                  <Box w='40px'>
                                    {/* {(!isMobile || (isMobile && isSupervisor)) && (  */}
                                      <ButtonNonaryWithIconOnly
                                        h='24px'
                                        w='24px'
                                        name={'uploadFile'}
                                        icon='uploadFile'
                                        iconsize='24px'
                                        onClick={() => { handleModeChange('File'); }}
                                        isDisabled={modeIsLocked}
                                      />
                                    {/* )} */}
                                  </Box>
                                  
                                  {/* Center-aligned SINGLE and COMBINE buttons */}
                                  {/* {(mode!=='File') &&  */}
                                  <Flex justify="center" align="center" flex="1" paddingLeft={'12px'}>
                                    <ButtonDuodenaryPlain
                                      w='105px'
                                      name='single'
                                      value='SINGLE'
                                      onClick={() => { handleModeChange('Single'); }}
                                      isDisabled={modeIsLocked}
                                      state={mode === 'Single' ? 'selected' : 'default'}
                                    />
                                    <ButtonDuodenaryPlain
                                      w='120px'
                                      name='combine'
                                      value='COMBINE'
                                      onClick={() => { handleModeChange('Combine'); }}
                                      isDisabled={modeIsLocked}
                                      state={mode === 'Combine' ? 'selected' : 'default'}
                                    />
                                  </Flex>
                                  {/* } */}

                                  <Box w='40px' />
                                </Flex>
                              )}

                              {/* Second row - centered button */}
                              <Flex justify="center" w="90%" my={'25px'}>
                                {!showMultiPictureButtons && (
                                  <ButtonSeptenaryWithIconOnly
                                    h='64px'
                                    w='64px'
                                    mt='5px'
                                    name='capture'
                                    icon='capture'
                                    iconsize='40px'
                                    // onClick={capturePhoto}
                                    onClick={() => capturePhoto(webcamRef)}
                                  />
                                )}
                              </Flex>
                            </Flex>
                          </>
                        )}
                      </Box>
                      {/* <canvas ref={canvasRef} width={640} height={480} style={{ display: 'none' }}></canvas> */}
                      </>}
                    </>
                  </VStack>
                </Box>}
              </Box>

              {(showUploadForm || receiptHasIssue) && (
                <Box mt={'25px'}>

                  <Box paddingTop={'25px'}>
                    <FormSelectSimple
                      register={register}
                      control={control}
                      errors={errors}
                      isRequired={true}
                      rules={{ required: "Statement Type is required" }}
                      onChange={e => updateSelectedStatementType(e)}
                      selectedoption={selectedStatementType||''}
                      optionsArray={STATEMENT_TYPE_OPTIONS}
                      fieldname='selectStatementType'
                      prettyname='Type'
                      fieldlabel="Type"
                      placeholder={'Select type'}
                      issearchable={false}
                    />
                  </Box>

                  <Box paddingTop={'25px'}>
                    <FormSelectSimple
                      register={register}
                      control={control}
                      errors={errors}
                      isRequired={true}
                      rules={{ required: "Expense Category is required" }}
                      onChange={e => updateSelectedExpenseCategory(e)}
                      selectedoption={selectedExpenseCategory||''}
                      optionsArray={expenseCategories}
                      fieldname='selectExpenseCategory'
                      prettyname='Expense Category'
                      fieldlabel="Expense Category"
                      placeholder={'Select expense category'}
                      issearchable={false}
                    />
                  </Box>

                  {((showUploadForm && showUploadFormRest) || receiptHasIssue || selectedActionType==='edit') && (<>
                    <Box paddingTop={'25px'}>
                      <TextareaInput
                        register={register}
                        errors={errors}
                        // rules={{ required: "Required" }}
                        fieldname="addedNotes"
                        fieldlabel="Expense Notes"
                        prettyname="Expense Notes"
                        placeholder="Enter any notes about this expense"
                        // defaultvalue={isEditMode ? attachReceiptParams?.addedNotes||transactionData?.capitalOneCreditCardTransactionReceipt?.addedNotes : ''}
                        // onChange={handleJobDescriptionChange}
                        // onBlur={handleJobDescriptionChange}
                        // isRequired
                      />
                    </Box>
                    
                    <Box paddingTop={'25px'}>
                      <FormSelectSimple
                        key='Division'
                        register={register}
                        control={control}
                        errors={errors}
                        isRequired={true}
                        rules={{ required: "Division is required" }}
                        fieldname="selectDivision"
                        fieldlabel="Division"
                        placeholder={'Select division'}
                        optionsArray={divisionOptions?.map((division, index) => ({
                          key: index,
                          value: division.value,
                          label: division.label
                        }))}
                        onChange={(e) => updateSelectedDivision(e)}
                        selectedoption={selectedDivision||''}
                        issearchable={false}
                      />
                    </Box>

                    <Box paddingTop={'25px'}>
                      <FormSelectSimple
                        key='Client'
                        register={register}
                        control={control}
                        errors={errors}
                        isRequired={true}
                        rules={{ required: "A Client or - None - is required" }}
                        onChange={e => updateSelectedClient(e)}
                        selectedoption={selectedClient||''}
                        optionsArray={clients}
                        fieldname='selectClient'
                        prettyname='Client'
                        fieldlabel="Client"
                        placeholder={'Select a Client or - None -'}
                        issearchable={false}
                      />
                    </Box>

                    {isIFTATracked ? (<>
                      <Box paddingTop={'25px'}>
                        <FormSelectSimple
                          register={register}
                          control={control}
                          errors={errors}
                          isRequired={true}
                          rules={{ required: "OTR Unit is required" }}
                          onChange={(event, action) => handleIFTAUnitChange(event, action)}
                          selectedoption={selectedIFTAUnitOption}
                          optionsArray={iftaUnitOptions.map(unit => ({
                            value: unit.value,
                            label: unit.label
                          }))}
                          fieldname="selectOTRUnit"
                          placeholder={'Select OTR unit'}
                          fieldlabel="OTR Unit"
                          issearchable={false}
                        />
                      </Box>

                      <Box paddingTop={'25px'}>
                        <FormSelectSimple
                          register={register}
                          control={control}
                          errors={errors}
                          isRequired={true}
                          rules={{ required: "State is required" }}
                          onChange={e => updateSelectedState(e)}
                          selectedoption={selectedState||''}
                          optionsArray={stateOptions}
                          fieldname='selectState'
                          prettyname='State'
                          fieldlabel="State"
                          placeholder={'Select state'}
                        />
                      </Box>

                      <Box paddingTop={'25px'}>
                        <TextInput
                          register={register}
                          errors={errors}
                          // fieldtype="tel"
                          fieldtype="number" step="any"
                          fieldname="odometer"
                          fieldlabel="Odometer"
                          prettyname="Odometer"
                          placeholder="Enter odometer miles"
                          onChange={handleOdometerChange}
                          onKeyPress={handleOdometerKeyPress}
                          isRequired
                        />
                      </Box>

                      <Box paddingTop={'25px'}>
                        <TextInput
                          register={register}
                          errors={errors}
                          fieldtype="number"
                          fieldname="gallons"
                          fieldlabel="Gallons"
                          prettyname="Gallons"
                          placeholder="Enter gallons purchased"
                          onChange={handleGallonsChange}
                          onKeyPress={handleGallonsKeyPress}
                          isRequired
                        />
                      </Box>

                      </>
                    ) : 
                      <Box paddingTop={'25px'}>
                        <FormSelectMulti
                          register={register}
                          control={control}
                          errors={errors}
                          rules={{
                            validate: (value) =>
                              !isUnitRequiredRef.current ||
                              (Array.isArray(value) && value.length > 0) ||
                              'A unit selection is required',
                          }}
                          onChange={(event, action) => handleUnitsChange(event, action)}
                          selectedoption={selectedUnits}
                          optionsArray={unitOptions.map((unit) => ({
                            value: unit.value,
                            label: unit.label
                          }))}
                          fieldname="units"
                          placeholder={isUnitRequired ? 'Select Unit(s)' : 'Select units if applicable'}
                          fieldlabel="Units"
                          issearchable={false}
                          isMulti
                        />
                      </Box>
                    }
                  </>)}

                  <Box paddingTop={'50px'}>
                    <Flex gap={4} justifyContent="center" width="100%">
                    
                      {/* <Button 
                        onClick={resetForm} 
                        isDisabled={isSubmitting}
                        colorScheme="red" 
                        width="100%"
                        >Reset</Button> */}
                      <ButtonQuaternaryPlain
                        type="button"
                        // onClick={handleSubmit(formSubmit, onError)}
                        onClick={resetForm} 
                        width="100%"
                        name="resetForm"
                        value={'Reset'}
                        isDisabled={isSubmitting}
                      />

                      <ButtonPrimaryPlain
                        type="submit"
                        onClick={handleSubmit(formSubmit, onError)}
                        width="100%"
                        name="submit"
                        value={isSubmitting ? "Uploading..." : "Upload"}
                        isDisabled={selectedExpenseCategory==='' || isSubmitting}
                      />
                      
                    </Flex>
                  </Box>

                </Box>
                
              )}
            </Flex>
            <Box h={'300px'}></Box>
          </>
        )}

      </Container>

      <CenteredSubmitWithProgressScrollModal
        isModalOpen={isSubmitModalOpen}
        onModalClose={onSubmitModalClose}
        content={submitModalContent||''}
        closeButtonDisabled={submitModalCloseDisabled}
        handleSubmitModalClosed={handleSubmitModalClosed}
        progress={submissionProgress}
        successMessage={'Receipt uploaded successfully!'}
        closeButtonVisible={true}
      />


      <CenteredSingleButtonConfirmationModal
        isModalOpen={isConfirmModalOpen}
        onModalClose={onConfirmModalClose}
        headerIcon={confirmationModalIcon}
        headerIconColor={confirmationModalIconColor}
        headerText={confirmationModalHeaderText}
        bodyContent={confirmationModalContent}
        closeButtonDisabled={false}
        handleSubmitModalClosed={handleConfirmModalClosed}
      />
    </>

  );
};

QuickCameraUploadStatement.propTypes = {
  id: PropTypes.string,
  showCancel: PropTypes.bool,
  selectedActionType: PropTypes.string,
  targetTeamMemberId: PropTypes.string,
  forceFileMode: PropTypes.bool,
  attachReceiptParams: PropTypes.shape({
    accountNumber: PropTypes.string,
    addedNotes: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    amount: PropTypes.string,
    date: PropTypes.string,
    hasInstantNotification: PropTypes.bool,
    hasIssue: PropTypes.bool,
    issue: PropTypes.string,
    merchantEntityName: PropTypes.string,
    unitId: PropTypes.string,
    units: PropTypes.array,
    expenseCategoryId: PropTypes.string,
    divisionId: PropTypes.string,
    clientId: PropTypes.string,
    odometer: PropTypes.string,
    gallons: PropTypes.string,
    stateTwoChar: PropTypes.string,
    iftaFuelTaxTrackId: PropTypes.string,
  }),
  onClose: PropTypes.func,
};